import React from 'react';

const renderDescription = (content, highlightedTextRaw) => {
  if (!highlightedTextRaw) return content;

  const highlightedTextArray =
    typeof highlightedTextRaw === 'string'
      ? [highlightedTextRaw]
      : highlightedTextRaw;
  let contentArray = content.split('{highlightedText}');
  const newContentArray = [];
  (contentArray || []).forEach((text, index) => {
    newContentArray.push(text);
    if (highlightedTextArray[index]) {
      newContentArray.push(
        <span className="bg-gray-200 text-14 px-0.8 py-0.4 mx-0.4 rounded-0.4 monospaced">
          {highlightedTextArray[index]}
        </span>,
      );
    }
  });

  return newContentArray;
};

export { renderDescription };
